import React from 'react';
import { MessageSquare, ThumbsUp, Flag } from 'lucide-react';

export const JudgeFeedback = ({ judge, judgeName, comment, timestamp, highlights = [], isDarkMode }) => {
  // Handle both prop structures - direct props or judge object
  const displayName = judge?.name || judgeName || "Judge";
  const displayComment = judge?.comment || comment || "No feedback available.";
  const displayTimestamp = judge?.timestamp || timestamp;
  const displayHighlights = judge?.highlights || highlights || [];

  return (
    <div className={`rounded-lg ${
      isDarkMode 
        ? "bg-[#252D42] border border-white/10" 
        : "bg-base-200"
    }`}>
      <div className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <MessageSquare className={`w-5 h-5 ${isDarkMode ? "text-blue-400" : "text-primary"}`} />
          <h3 className={`${isDarkMode ? "text-white" : "text-base-content"} font-medium`}>Judge Feedback</h3>
        </div>

        {/* Judge Info */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
              isDarkMode 
                ? "bg-blue-500/10 text-blue-400" 
                : "bg-primary/10 text-primary"
            }`}>
              <span>{displayName && typeof displayName === 'string' ? displayName.charAt(0) : "J"}</span>
            </div>
            <div>
              <p className={`${isDarkMode ? "text-white" : "text-base-content"} font-medium`}>{displayName}</p>
              {displayTimestamp && (
                <p className={`text-xs ${isDarkMode ? "text-gray-400" : "text-base-content/60"}`}>{displayTimestamp}</p>
              )}
            </div>
          </div>
        </div>

        {/* Main Feedback */}
        <div className={`prose prose-sm max-w-none ${
          isDarkMode ? "text-gray-300" : "text-base-content/70"
        }`}>
          {displayComment}
        </div>

        {/* Highlights Section */}
        {displayHighlights.length > 0 && (
          <div className="mt-4 space-y-2">
            <h4 className={`text-sm font-medium ${isDarkMode ? "text-white" : "text-base-content"}`}>Key Points</h4>
            {displayHighlights.map((highlight, index) => (
              <div 
                key={index}
                className={`flex items-start gap-2 p-2 rounded-lg ${
                  isDarkMode ? "bg-white/5" : "bg-base-300"
                }`}
              >
                {highlight.type === 'positive' ? (
                  <ThumbsUp className="w-4 h-4 text-success mt-0.5" />
                ) : (
                  <Flag className="w-4 h-4 text-warning mt-0.5" />
                )}
                <p className={`text-sm ${isDarkMode ? "text-gray-300" : "text-base-content"}`}>{highlight.text}</p>
              </div>
            ))}
          </div>
        )}

        {/* Action Buttons */}
        <div className="flex gap-2 mt-4">
          <button className={`px-3 py-1.5 text-sm rounded-lg border ${
            isDarkMode 
              ? "border-white/10 text-gray-300 hover:bg-white/5" 
              : "btn btn-sm btn-outline"
          } gap-2`}>
            Download Full Notes
          </button>
          <button className={`px-3 py-1.5 text-sm rounded-lg ${
            isDarkMode 
              ? "text-gray-400 hover:bg-white/5" 
              : "btn btn-sm btn-ghost"
          }`}>Share</button>
        </div>
      </div>
    </div>
  );
};